// extracted by mini-css-extract-plugin
module.exports = {"container":"Team_container__7-5wy","left":"Team_left__1jrvh","right":"Team_right__2drqp","error":"Team_error__3IE8r"};